import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Button, Modal, Spin, Row } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { queries } from '../../graphql/graphql';
import FileListGrid from '../Upload/FileListGrid';

export const FindPhotos = props => {
  const { decorId, setPhotos, photos, id } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data = {}, loading, refetch } = useQuery(queries.FIND_PHOTOS, {
    variables: { decorId, id }
  });
  const { findPhotos } = data;

  const showModal = () => {
    refetch();
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAdd = file => {
    const newList = [].concat(photos);
    newList.push({
      uid: uuidv4(),
      url: file.original,
      status: 'done',
      selected: false
    });
    setPhotos(newList);
    // setIsModalOpen(false);
  };

  const getPhotoAction = file => {
    const actions = [
      <Button type="primary" onClick={() => onAdd(file)} key="preview">
        Add
      </Button>
    ];

    return actions;
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Find Photos
      </Button>
      <Modal title="Photos" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={[16, 16]}>
            {findPhotos && findPhotos.photos && findPhotos.photos.length && (
              <FileListGrid
                compact={false}
                fileList={findPhotos.photos}
                customActions={getPhotoAction}
              />
            )}
          </Row>
        )}
      </Modal>
    </>
  );
};
